import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useCurrentUser } from "@/api/hooks";

/** Wraps protected routes. While the /auth/me probe is in flight we
 * render a minimal splash; on null we redirect to /login (preserving
 * intended path so the user lands where they were headed after sign-
 * in). On a CurrentUser, we render the children via Outlet. */
export function RequireAuth() {
  const me = useCurrentUser();
  const location = useLocation();

  if (me.isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-paper text-sm text-graphite-soft">
        Loading…
      </div>
    );
  }

  if (!me.data) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
